import React from "react";
import { useTranslation } from "react-i18next";
import SortModal from "../sortModal";
import useExerciseFilters from "./useExerciseFilters";
import { ExerciseFiltersObject } from "../../hooks/useAdditionalHooks";
import InstructorSortModal from "./InstructorSortModal";
import EAModal from "../../../shared/Modal/EAModal";

interface IProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  filters: ExerciseFiltersObject;
  setFilters: (filters: ExerciseFiltersObject) => void;
  dateFromState: Date;
  dateToState: Date;
}

const ExerciseFltersModal: React.FC<IProps> = ({ open, setOpen, filters, setFilters, dateFromState, dateToState }) => {
  const { t } = useTranslation();
  const { exerciseGroups, zones, humans } = useExerciseFilters(dateFromState, dateToState);

  return (
    <EAModal isOpen={open} hideButtons onClose={() => setOpen(false)} title={t("filtrowanie")}>
      <SortModal
        title={t("wybierz_zajecia")}
        data={exerciseGroups}
        selectedValue={filters.exerciseGroups}
        onSelect={(value) => setFilters({ ...filters, exerciseGroups: value })}
      />
      <SortModal
        title={t("wybierz_strefy")}
        data={zones}
        selectedValue={filters.zones}
        onSelect={(value) => setFilters({ ...filters, zones: value })}
      />
      <InstructorSortModal
        title={t("wybierz_instruktora")}
        data={humans}
        selectedValue={filters.humans}
        onSelect={(value) => setFilters({ ...filters, humans: value })}
      />
    </EAModal>
  );
};

export default ExerciseFltersModal;
